<template>
    <div class="login-all">

        <!-- <particles-bg type="random" :bg="true"/> -->
        <vue-particles
        class="login-background"
        color="#409EFF"
        :particleOpacity="0.7"
        :particlesNumber="60"
        shapeType="circle"
        :particleSize="6"
        linesColor="#409EFF"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push">
        </vue-particles>
        <div class="login-main">

            <!-- 登录 -->
            <div class="right-login ">
                <transition name="el-zoom-in-top">
                    <div class="login-widow" v-if="isChangePass">
                        <div class="login-top">MOOBY YOHO</div>
                        <div class="login-input">
                            <div class="input-tip">用户名</div>
                            <el-input v-model="username" clearable auto-complete="off"></el-input>
                            <div class="input-tip">密码</div>
                            <el-input ref="loginInput" placeholder="请输入密码"  v-model="password"  show-password  @keyup.enter.native="doLogin" auto-complete="off"> </el-input>
                        </div>
                        <div class="password-tip" @click="changePass">忘记密码？</div>
                        <el-button type="primary" style="margin:20px 20px;width:calc(100% - 40px)" @click="doLogin" :loading="load">登录</el-button>
                    </div>
                </transition>
                <!-- 忘记密码 -->
                <transition name="el-zoom-in-top">
                    <div class="login-widow" v-if="!isChangePass">
                        <div class="login-top">
                            <div class="back-login" @click="changePass"><i class="el-icon-back"></i></div>
                            修改密码
                        </div>
                        <div class="login-input">
                            <div class="input-tip">手机号码</div>
                            <el-input v-model="username" placeholder="请输入手机号码">
                                <el-select v-model="phonetype" placeholder="请选择" slot="prepend" style="width:70px;">
                                    <el-option key="86" label="+86" value="86"></el-option>
                                    <el-option key="1" label="+1"   value="1"></el-option>
                                </el-select>
                            </el-input>
                            <div class="input-tip">新密码</div>
                            <el-input  v-model="newPassword" placeholder="请输入新密码" show-password></el-input>
                            <div class="input-tip">验证码</div>
                            <el-input placeholder="请输入验证码" v-model="code" @keyup.enter.native="resetPsw" ref="forgetBlur">
                                <el-button slot="append" @click="getCode" style="width:120px" :disabled="isDsiabled">{{codeSecond}}</el-button>
                            </el-input>
                        </div>
                        <el-button type="primary" style="margin:20px 20px;width:calc(100% - 40px)" :loading="forgetLoad" @click="resetPsw">确认修改</el-button>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<style scoped>
.login-background {
  background: linear-gradient(-180deg, #dceaf2 0%, #ffffff 100%);
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
}
.login-all{width:100%;height:100%; background: rgba(252, 218, 252, 0.5);}
.login-main{margin:0 auto;width:900px;height:100%;display: flex;flex-direction: row}


.right-login{position: relative;flex: 1;height:100%}
.login-widow{position: absolute;top:50%;left:50%;transform: translate(-50%, -50%);width:450px;height:auto;padding-bottom: 25px; background-color:#fff;border-radius: 5px; box-shadow: #000000;}
.login-top{position: relative;width:100%;height:50px;line-height: 50px;text-align: center;font-size: 18px;color:#409EFF;font-weight: 700;border-bottom:1px solid #ddd;
overflow: hidden}
.login-input{padding:20px;width:calc(100% - 40px)}
.input-tip{margin-top:25px;line-height: 30px;font-size: 14px;color:#606266}
.password-tip{margin-top:5px;text-align: center;line-height: 30px;font-size: 15px;color:#409EFF;}
.password-tip:hover{color: #409EFF;cursor: pointer;}
.back-login{position: absolute;top:0;left:0;width:50px;height:100%;border-top-left-radius: 5px}
.back-login:hover{cursor: pointer;background-color: #409EFF;color:#fff}
</style>

<script>

import { login } from '@/api/login.js'
// import { ParticlesBg } from "particles-bg-vue"
export default {
    // components: { ParticlesBg },
    data: function(){
        return {
            username: '',
            password: '',
            load:false,   //判断 登陆 按钮是否显示 loading
            newPassword:'',  //忘记密码  新密码
            forgetLoad:false, //判断 忘记密码 按钮是否显示 loading
            phonetype:'86',
            codeSecond: '获取验证码',   //验证码 读秒 
            code: '',       //验证码
            isChangePass: true,
            // 禁用获取验证码
            isDsiabled: false,

        }
    },
    methods: {
        changePass() {
            // 修改密码
            this.isChangePass = !this.isChangePass
        },
        getCode(){
            
        },
        timeDown() {
            // 倒计时
            // 禁用获取验证码
            this.isDsiabled = true
            this.codeSecond = 60 + 's'
            var codeTemp = 59
            const that = this
            const timer = setInterval(function(){
                that.codeSecond = codeTemp + 's'
                codeTemp--
                if(codeTemp == 0){
                    that.codeSecond = '获取验证码'
                    // 取消禁用验证码
                    that.isDsiabled = false
                    clearInterval(timer)
                }
            },1000)
        },
        doLogin(){
            this.$refs.loginInput.blur();
            if(this.username == ""){
                this.$message.error('警告哦，请先输入用户名');
                return false
            }
            if(this.password == ""){
                this.$message.error('警告哦，请先输入新密码');
                return false
            }
         
            

            let params = {
                account:this.username,
                password:this.password,
            }
            this.load = true;
            login(params).then(res => {
                if(res) {
                    this.setToken(res.access_token);
                    this.$router.push({path:'/account/index'})
                }
                
            }).finally( () => {
                this.load = false;
            })
        },
        resetPsw(){
            this.$refs.forgetBlur.blur();
            if(this.username == ""){
                this.$message.error('警告哦，请填写用户名');
                return false
            }
            if(this.newPassword == ""){
                this.$message.error('警告哦，请填写密码');
                return false
            }
            if(this.code == ""){
                this.$message.error('警告哦，请先输入验证码');
                return false
            }
            // let params = {
            //     phone:this.username,
            //     phonetype:this.phonetype,
            //     code:this.code
            // }
            // this.forgetLoad = true;
            // checkCode(params).then(res => {
            //     if(res.status === 1){
            //         let data = {
            //             phone:this.username,
            //             password:this.newPassword
            //         }
            //         resetPassword(data)
            //         .then(res => {
            //             this.forgetLoad = false;
            //             if(res.status === 1){
            //                 this.$message('重置密码成功');
            //                 this.isChangePass = !this.isChangePass
            //             }else{
            //                 this.$message.error(`Opps，${res.msg}`);
            //             }
            //         })
            //     }else{
            //         this.forgetLoad = false;
            //         this.$message.error(`Opps，${res.msg}`);
            //     }
            // })
        }
    },

}
</script>



